<template>
  <div class="row card">
    <div class="col s12 m12 animated flipInX">
      <h5>Transaction History</h5>
      <ul class="collapsible popout">
        <li class="active">
          <div class="collapsible-header">
            <i class="fa fa-lightbulb-o"></i>Power Transactions
            <i class="material-icons right">arrow_drop_down</i>
          </div>
          <div class="collapsible-body">
            <power-history />
          </div>
        </li>
        <li>
          <div class="collapsible-header">
            <i class="fa fa-mobile"></i>Airtime Transactions
            <i class="material-icons right">arrow_drop_down</i>
          </div>
          <div class="collapsible-body">
            <airtime-history />
          </div>
        </li>
        <li>
          <div class="collapsible-header">
            <i class="fa fa-tv"></i> TV Transactions
            <i class="material-icons right">arrow_drop_down</i>
          </div>
          <div class="collapsible-body">
            <tv-history />
          </div>
        </li>
        <li>
          <div class="collapsible-header">
            <i class="fa fa-globe"></i> Data Transactions
            <i class="material-icons right">arrow_drop_down</i>
          </div>
          <div class="collapsible-body">
            <data-history />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import PowerHistory from '@/components/history/PowerHistory.vue'
import AirtimeHistory from '@/components/history/AirtimeHistory.vue'
import TvHistory from '@/components/history/TvHistory.vue'
import DataHistory from '@/components/history/DataHistory.vue'
export default {
  name: 'Tranaction',
  components: {
    PowerHistory,
    AirtimeHistory,
    TvHistory,
    DataHistory
  },
  created() {
    if (localStorage.getItem('userType') != 1) {
      window.location.assign('/')
    }
  },
  mounted() {
    $('.bills__side__wrapper').removeClass('left_out')
    $('.collapsible').collapsible()
  },
  data() {
    return {}
  },
  methods: {}
}
</script>
<style scoped>
.card {
  padding: 15px 20px;
}
</style>
